export type ApiError = Error & { status?: number };

export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;

  const candidate = error as {
    status?: unknown;
    response?: { status?: unknown };
  };

  if (typeof candidate.status === 'number') return candidate.status;
  if (typeof candidate.response?.status === 'number') {
    return candidate.response.status;
  }

  return undefined;
};

export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (typeof error === 'object' && error !== null) {
    const candidate = error as {
      message?: unknown;
      response?: { data?: { message?: unknown } };
    };
    const responseMessage = candidate.response?.data?.message;

    if (typeof responseMessage === 'string') return responseMessage;
    if (Array.isArray(responseMessage)) return responseMessage.join(', ');
    if (typeof candidate.message === 'string') return candidate.message;
  }

  return fallback;
};

export const createApiError = (error: unknown, fallback: string): ApiError => {
  const apiError = new Error(getApiErrorMessage(error, fallback)) as ApiError;
  apiError.status = getApiErrorStatus(error);

  return apiError;
};

export const normalizeApiError = (
  error: unknown,
  fallback = 'Request failed'
): ApiError => {
  if (error instanceof Error && typeof getApiErrorStatus(error) === 'number') {
    return error as ApiError;
  }

  return createApiError(error, fallback);
};

export const isServerErrorStatus = (status?: number | null): status is number =>
  typeof status === 'number' && status >= 500;
